import Images from "assets/images"
import { MtProject } from "server/models"
import {
    UserData,
    UserSettings,
    GetFile,
} from "client/store"

export const ReportDateFormatted = () => {
    const date = new Date()
    const year = date.getFullYear()
    const month = date.getMonth() + 1
    const monthFormatted = (month > 9) ? month.toString() : `0${month}`
    const day = date.getDate()
    const dayFormatted = (day > 9) ? day.toString() : `0${day}`

    const hours = date.getHours()
    const hoursFormatted = (hours > 9) ? hours.toString() : `0${hours}`
    const minutes = date.getMinutes()
    const minutesFormatted = (minutes > 9) ? minutes.toString() : `0${minutes}`
    const seconds = date.getSeconds()
    const secondsFormatted = (seconds > 9) ? seconds.toString() : `0${seconds}`

    const dateFormatted = `${year}-${monthFormatted}-${dayFormatted} ${hoursFormatted}:${minutesFormatted}:${secondsFormatted}`
    return dateFormatted
}

// load account logo
export const ReportAccountLogo = (userData: UserData) => {
    const accountDefaultLogo = `${window.location.origin}${Images.accountLogo}`
    return GetFile(userData.accountLogo, accountDefaultLogo).then((res) => res.data)
}

// load project logo
export const ReportProjectLogo = (project: MtProject, userSettings: UserSettings) => {
    const defaultProjectLogo = `${window.location.origin}${Images.projectLogo}`
    const logo = project.logo && project.logo.versions.length
        ? project.logo
        : userSettings.project.defaultLogo
    return GetFile(logo, defaultProjectLogo).then((res) => res.data)
}
